import moduleName from './module-name';

// When Category filter is used, don't render these modules.
export default {
    moduleNames: [
        moduleName.NAVIGATION_CAROUSEL_V2,
        moduleName.ITEMS_CAROUSEL,
        moduleName.MARKETING_BANNER,
        moduleName.MARKETING_BANNER_V2
    ]
};
